import React, { useContext } from 'react'
import './header.sass'
import { DarkModeContext } from '../../global/Theme'


export default function HeaderBlock({ img, text, handleClick }) {
    const { isDark } = useContext(DarkModeContext);

    return (
        <div className={`lover-header-block ${isDark ? 'lover-header-dark' : 'lover-header-light'}`}>
          {handleClick ?  <img onClick={handleClick} 
          src={require(`../../assets/icons/${img}`)} /> 
          : <img src={require(`../../assets/icons/${img}`)} /> }
            <h1>{text}</h1>
        </div>
    )
}
